/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An organization linked to a property, enriched with the per-link role.
 * @export
 * @interface PropertyLinkedOrganization
 */
export interface PropertyLinkedOrganization {
    /**
     * 
     * @type {number}
     * @memberof PropertyLinkedOrganization
     */
    readonly id: number;
    /**
     * PA firm that owns this record
     * @type {number}
     * @memberof PropertyLinkedOrganization
     */
    companyId: number;
    /**
     * Free-form organization type (e.g. insurance_company, contracting_company)
     * @type {string}
     * @memberof PropertyLinkedOrganization
     */
    orgType: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedOrganization
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedOrganization
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedOrganization
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedOrganization
     */
    address?: string | null;
    /**
     * Must be a fully-qualified URL starting with http:// or https://
     * @type {string}
     * @memberof PropertyLinkedOrganization
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyLinkedOrganization
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyLinkedOrganization
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyLinkedOrganization
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PropertyLinkedOrganization
     */
    readonly updatedAt: Date;
    /**
     * Role of this organization for the property (from the organization-property link).
     * @type {string}
     * @memberof PropertyLinkedOrganization
     */
    role?: string | null;
}

/**
 * Check if a given object implements the PropertyLinkedOrganization interface.
 */
export function instanceOfPropertyLinkedOrganization(value: object): value is PropertyLinkedOrganization {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('orgType' in value) || value['orgType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PropertyLinkedOrganizationFromJSON(json: any): PropertyLinkedOrganization {
    return PropertyLinkedOrganizationFromJSONTyped(json, false);
}

export function PropertyLinkedOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyLinkedOrganization {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'orgType': json['orgType'],
        'name': json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'address': json['address'] == null ? undefined : json['address'],
        'website': json['website'] == null ? undefined : json['website'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function PropertyLinkedOrganizationToJSON(json: any): PropertyLinkedOrganization {
    return PropertyLinkedOrganizationToJSONTyped(json, false);
}

export function PropertyLinkedOrganizationToJSONTyped(value?: Omit<PropertyLinkedOrganization, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'orgType': value['orgType'],
        'name': value['name'],
        'phone': value['phone'],
        'email': value['email'],
        'address': value['address'],
        'website': value['website'],
        'notes': value['notes'],
        'createdBy': value['createdBy'],
        'role': value['role'],
    };
}

